import { PlusOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { AccessControl } from 'components/AccessControl';
import {
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useFilters } from 'hooks/useFilters';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { useEffect, useState } from 'react';
import { PushNotificationService } from 'services/PushNotificationService';
import { ActionsWrapper } from 'ui/ActionsWrapper';
import { PushNotificationDetail } from './PushNotificationDetail';
import { PushNotificationForm } from './PushNotificationForm';
import { PushNotificationTable } from './PushNotificationTable';

const PAGE_TITLE = 'Пуш отправки';

function PushNotification() {
  useDocumentTitle(PAGE_TITLE);
  const { setCount } = useHeaderChanger(PAGE_TITLE);
  const [pushNotifications, setPushNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();
  const {
    page,
    totalRows,
    perPage,
    setTotalRows,
    setPagination,
    resetPagination,
  } = usePagination();
  const { filters, handleFilters } = useFilters({
    start_date: null,
    end_date: null,
    send_frequency: null,
  });

  useEffect(() => {
    fetchPushNotifications();
  }, [page, perPage, filters]);

  const fetchPushNotifications = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } =
        await PushNotificationService.getPushNotifications(
          page,
          perPage,
          filters
        );

      setPushNotifications(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await PushNotificationService.deletePushNotification(
        activeRecord.id
      );

      if (isDeleted) {
        closeDrawer();
        fetchPushNotifications();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <ActionsWrapper placeEnd>
        <AccessControl pageId="pushNotification" action="create">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={openCreateForm}
          >
            Создать
          </Button>
        </AccessControl>
      </ActionsWrapper>

      <PushNotificationDetail
        activeRecord={activeRecord}
        isActive={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
      />

      <PushNotificationTable
        items={pushNotifications}
        loading={loading}
        filters={filters}
        current={page}
        pageSize={perPage}
        totalRows={totalRows}
        onRowClick={openDrawer}
        onChange={setPagination}
        onFilter={(value) => {
          handleFilters(value);
          resetPagination();
        }}
      />

      <PushNotificationForm
        initialValues={activeRecord}
        isActive={formIsActive}
        onClose={closeForm}
        onSuccess={fetchPushNotifications}
      />
    </>
  );
}

export { PushNotification };
